export class StoreKeysConstants {
    static AUTH_TOKEN = 'authToken';
    static USER_DATA = 'userData';
    static APP_DATA = 'appData';
}